module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-previewer"
  }, [(_vm.isDisplaying) ? _c('div', [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isDisplaying = false
      }
    }
  }, [_vm._v("Hide content")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.images.find(function (extension) { return _vm.name.endsWith(extension); })) ? _c('img', {
    attrs: {
      "src": _vm.source,
      "alt": _vm.name
    }
  }) : _vm._e(), _vm._v(" "), (_vm.videos.find(function (extension) { return _vm.name.endsWith(extension); })) ? _c('video', {
    attrs: {
      "controls": "",
      "controlsList": "nodownload"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.getStream(),
      "type": "video/mp4"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.audios.find(function (extension) { return _vm.name.endsWith(extension); })) ? _c('audio', {
    attrs: {
      "controls": "",
      "controlsList": "nodownload"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.getStream(),
      "type": "audio/mpeg"
    }
  })]) : _vm._e()]) : _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isDisplaying = true
      }
    }
  }, [_vm._v("Show content")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-011cde4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/FilePreviewer.vue
// module id = 425
// module chunks = 1